import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-mobile",
  "use": "icon-mobile-usage",
  "viewBox": "0 0 13 22",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 13 22\" id=\"icon-mobile\"><path d=\"M6.422 19.375a.982.982 0 1 0 0-1.964.982.982 0 0 0 0 1.964zM11.535 3.67H1.31v-.655c0-.723.585-1.308 1.308-1.308h7.61c.723 0 1.308.586 1.308 1.308zm0 11.778H1.31V4.979h10.226zm0 3.271c0 .723-.585 1.309-1.308 1.309h-7.61A1.308 1.308 0 0 1 1.31 18.72v-1.963h10.226zM10.227.4h-7.61A2.617 2.617 0 0 0 0 3.016V18.72a2.617 2.617 0 0 0 2.617 2.618h7.61a2.617 2.617 0 0 0 2.617-2.618V3.016A2.617 2.617 0 0 0 10.227.4z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol